const DATE_TIME_FORMAT = 'yyyyMMddHHmm';
const DATE_TIME_FORMAT2 = 'yyyyMMdd';
const DATE_TIME_FORMAT3 = 'yyyyMMddHHmmsszzz';

export const utilsService = {
	DATE_TIME_FORMAT,
	DATE_TIME_FORMAT2,
	DATE_TIME_FORMAT3,
	formatDateTime,
	formatTimeSpan,
	formatNumber,
	arrayBufferToBase64,
	base64ToArrayBuffer,
	convertFromSecondsTohhmmss,
	convertFromhhmmssToSeconds,
	convertUnixTimeToDate,
	convertFuelTypeCode,
	convertLimitType,
	convertLimitCycle,
	convertConsumptionError,
	formatValue,
	isPasswordNotValid,
	getCalendarLocale
};

function formatDateTime(dateTime, format) {
	if (dateTime === undefined) {
		return ""
	}

	const year = dateTime.getFullYear();

	let month = dateTime.getMonth() + 1;

	if (month < 10) {
		month = "0" + month;
	}

	let day = dateTime.getDate();

	if (day < 10) {
		day = "0" + day;
	}

	if (format == DATE_TIME_FORMAT2) {
		return `${day}.${month}.${year}`;
	}

	let hours = dateTime.getHours();

	if (hours < 10) {
		hours = "0" + hours;
	}

	let minutes = dateTime.getMinutes();

	if (minutes < 10) {
		minutes = "0" + minutes;
	}

	if (format == DATE_TIME_FORMAT) {
		return `${day}.${month}.${year} ${hours}:${minutes}`;
	}

	let seconds = dateTime.getSeconds();

	if (seconds < 10) {
		seconds = "0" + seconds;
	}

	const timezoneOffsetMinutes = dateTime.getTimezoneOffset();

	let timezoneOffsetHours =
		timezoneOffsetMinutes > 0
			? -(timezoneOffsetMinutes / 60)
			: Math.abs(timezoneOffsetMinutes / 60);

	if (timezoneOffsetHours < 10) {
		timezoneOffsetHours = `+0${timezoneOffsetHours}:00`;
	} else {
		timezoneOffsetHours = `+${timezoneOffsetHours}:00`;
	}

	return (
		[year, month, day, hours, minutes, seconds].join("") +
		timezoneOffsetHours
	);
}

function formatTimeSpan(seconds) {
	if (seconds < 0) {
		return seconds;
	}
	return new Date(seconds * 1000).toISOString().substr(11, 8);
}

function formatNumber(value, precision) {
	if (value === 0) return "0";

    if (value) {
        return new Intl.NumberFormat("ru-RU", {
            minimumFractionDigits: precision,
            maximumFractionDigits: precision
        }).format(value);
    }

    return "";
}

function arrayBufferToBase64(buffer) {
	let binary = "";
	const bytes = new Uint8Array(buffer);

	for (let i = 0; i < bytes.byteLength; i++) {
		binary += String.fromCharCode(bytes[i]);
	}

	return window.btoa(binary);
}

function base64ToArrayBuffer(base64) {
	const binaryString = window.atob(base64);

	const bytes = new Uint8Array(binaryString.length);
	for (let i = 0; i < binaryString.length; i++) {
		bytes[i] = binaryString.charCodeAt(i);
	}

	return bytes.buffer;
}

function convertFromSecondsTohhmmss(seconds) {
	if (seconds == 0) {
		return "00:00:00";
	}
	return new Date(seconds * 1000).toISOString().substr(11, 8);
}

function convertFromhhmmssToSeconds(time) {
	if (time) {
		const parts = time.split(":");
		return +parts[0] * 60 * 60 + +parts[1] * 60 + +parts[2];
	}
	return 0;
}

function convertUnixTimeToDate(unixTime) {
	if (unixTime == 0) {
		return "";
	}
	return new Date(unixTime * 1000);
}

function convertFuelTypeCode(fuelTypeCodes, fuelTypeCode) {
	for (let i = 0; i < fuelTypeCodes.length; i++) {
		if (fuelTypeCode == fuelTypeCodes[i].key) {
			return fuelTypeCodes[i].value;
		}
	}
}

function convertLimitType(limitTypes, limitType) {
	for (let i = 0; i < limitTypes.length; i++) {
		if (limitType == limitTypes[i].key) {
			return limitTypes[i].value;
		}
	}
}

function convertLimitCycle(limitCycles, limitCycle) {
	for (let i = 0; i < limitCycles.length; i++) {
		if (limitCycle == limitCycles[i].key) {
			return limitCycles[i].value;
		}
	}
}

function convertConsumptionError(consumptionErrors, error) {
	if (!error) {
		return "";
	}
	for (let i = 0; i < consumptionErrors.length; i++) {
		if (error == consumptionErrors[i].key) {
			return consumptionErrors[i].value;
		}
	}
}

function formatValue(key, value, localization, fuelVolumePrecision) {
	if (
	key == "startVolume" ||
	key == "endVolume" ||
	key == "startVolume15" ||
	key == "endVolume15" ||
	key == "startWaterVolume" ||
	key == "endWaterVolume" ||
	key == "averageTemperature" ||
	key == "endTemperature" ||
	key == "startTemperature" ||
	key == "startWeight" ||
	key == "endWeight" ||
	key == "inWeight" ||
	key == "outWeight" ||
	key == "inVolume" ||
	key == "inVolumeAdjusted" ||
	key == "outVolume" ||
	key == "outVolumeAdjusted" ||
	key == "leak" ||
	key == "startTemperature" ||
	key == "endTemperature" ||
	key == "topLimitLevel" ||
	key == "bottomLimitLevel" ||
	key == "volumeDifference" ||
	key == "volumeDifference15" ||
	key == "waterVolumeDifference" ||
	key == "weightDifference" ||
	key == "fuelConsumption" ||
	key == "fuelConsumption15" ||
	key == "fuelConsumptionDifference" ||
	key == "fuelWeightConsumption" ||
	key == "fuelWeightConsumptionDifference" ||
	key == "fuelConsumption15Difference" ||
	key == "fuelWeight" ||
	key == "fuelVolume" ||
	key == "fuelTemperature" ||
	key == "fuelVolume15" ||
	key == "beginFuelVolume15" ||
	key == "endFuelVolume15" ||
	key == "fuelWeightTtn" ||
	key == "fuelVolumeTtn" ||
	key == "fuelVolumeBefore" ||
	key == "fuelVolumeAfter" ||
	key == "fuelWeightBefore" ||
	key == "fuelWeightAfter" ||
	key == "fuelLevelBefore" ||
	key == "fuelLevelAfter" ||
	key == "fuelLevelBefore2" ||
	key == "fuelLevelAfter2" ||
	key == "fuelVolumeBefore2" ||
	key == "fuelVolumeAfter2" ||
	key == "fuelDensityTTN" ||
	key == "fuelVolumeTTN" ||
	key == "fuelWeightTTN"
	) {
	return utilsService.formatNumber(value, fuelVolumePrecision);
	} else if (
	key == "startChargeFuelConsumption" ||
	key == "endChargeFuelConsumption" ||
	key == "chargeFuelConsumption" ||
	key == "chargeFuelConsumptionOrder" ||
	key == "chargeFuelConsumptionOrderDiff" ||
	key == "startChargeFuelWeightConsumption" ||
	key == "endChargeFuelWeightConsumption" ||
	key == "chargeFuelWeightConsumption" ||
	key == "chargeFuelWeightConsumptionVolumeDiff" ||
	key == "chargeFuelConsumptionVolumeDiff" ||
	key == "chargeFuelVolume" ||
	key == "chargeFuelWeight"
	) {
	return utilsService.formatNumber(value, fuelVolumePrecision);
	} else if (
	key == "startDensity" ||
	key == "endDensity" ||
	key == "standartDensity" ||
	key == "fuelDensity" ||
	key == "fuelDensityTtn"
	) {
	return utilsService.formatNumber(value, 3);
	} else if (
	key == "chargeFuelTime" ||
	key == "inputTime" ||
	key == "notificationTime" ||
	key == "workBeginTime" ||
	key == "workEndTime" ||
	key == "updated" ||
	key == "startWork" ||
	key == "stopWork"
	) {
	return utilsService.formatDateTime(
		new Date(value * 1000),
		DATE_TIME_FORMAT
	);
	} else if (key == "workDiffTime" || key == "totalCounterStartWork" || key == "totalCounterStopWork") {
	return utilsService.formatTimeSpan(value);
	} else if (key == "startLevel" || key == "endLevel") {
	return utilsService.formatNumber(value / 10, 0);
	} else if (key == "fuelType") {
	return utilsService.convertFuelTypeCode(localization.data.common.fuelTypeCodeOptions, value);
	} else if (key == "limitType") {
	return utilsService.convertFuelTypeCode(localization.data.mainPage.limits.limitTypeOptions, value);
	} else if (key == "limitCycle") {
	return utilsService.convertLimitCycle(localization.data.mainPage.limits.cycleOptions, value);
	} else if (key == "fuelConsumptionErrorMessage") {
	return utilsService.convertConsumptionError(localization.data.mainPage.reports.fuelChargesReport.consumptionErrors, value);
	} else {
	return value;
	}
}

function isPasswordNotValid(password) {
  const MIN_PASSWORD_LENGTH = 8;

  if (password.length < MIN_PASSWORD_LENGTH) {
    return true;
  }

  if (!/[A-Z]/.test(password)) {
    return true;
  }

  if (!/[a-z]/.test(password)) {
    return true;
  }

  if (!/[0-9]/.test(password)) {
    return true;
  }

  if (!/[\W_]/.test(password)) {
    return true;
  }

  return false;
}

function getCalendarLocale(locale) {
	if (locale == 'en') {
		return 'en-US';
	} else if (locale == 'ru') {
		return 'ru-RU';
	} else {
		return 'uk-UA';
	}
}
